/**
 * The numbers a mole moves by. The sim, the path checker (pathing.ts) and the map generator all
 * read them from here, so "can a mole walk from one team to the other" is answered with the same
 * physics the game plays.
 */

export const GRAVITY = 0.42;
export const WALK_SPEED = 2.2;
/** Highest step a walking mole takes in one tick, px. */
export const STEP_UP = 10;
export const UNIT_HALF_W = 16;
export const UNIT_H = 56;
/** A voluntary fall shorter than this does no damage. */
export const SOFT_FALL = 160;
/** Jump launch: vertical speed (up) and the forward speed it holds in the air, both times the level's jump factor. */
export const JUMP_VY = 8.2;
export const JUMP_VX = 3.4;
/** Terminal fall speed, px per tick. */
export const MAX_FALL = 16;
/** Air steering: how fast a held direction pulls the mid-jump speed toward JUMP_VX. */
export const AIR_STEER = 0.08;
